import { render, staticRenderFns } from "./activityTransferUsers.html?vue&type=template&id=631835d6&external"
import script from "./activityTransferUsers.vue?vue&type=script&lang=js"
export * from "./activityTransferUsers.vue?vue&type=script&lang=js"
import style0 from "./activityTransferUsers.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports